// A failed backend call. `status` is the HTTP status and `code` the machine
// word of a `detail: { code }` answer (the 409s of the coach earnings routes),
// null when the answer carried none; `message` is the API's own words.
export class BackendError extends Error {
  readonly status: number
  readonly code: string | null

  constructor(message: string, status: number, code: string | null = null) {
    super(message)
    this.name = 'BackendError'
    this.status = status
    this.code = code
  }
}
